import React, {useEffect, useState} from 'react';
import api from "../../../../api/axios.js";
import Cookies from "js-cookie";

const LocationReportListSingle = ({company, revenue, isLast}) => {
    const [OhcAmount, setOhcAmount] = useState(0);
    const accessToken = Cookies.get('accessToken');

    useEffect(() => {
        const fetchData = async () => {
            const ohcResponse = await api.get(
                `/api/v1/overhead?cs=${company}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            setOhcAmount(ohcResponse.data.ohc);
        }
        fetchData()
    });

    const updateOhcAmount = async (amount) => {
        if (amount === '' || amount === null || amount === undefined || amount < 0) {
            amount = 0;
        }
        await api.post(
            `/api/v1/overhead?cs=${company}&ohc=${amount}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then(() => setOhcAmount(amount));
    }

    return (
        <div
            className={`flex justify-between w-full py-4 ${
                !isLast ? 'border-b' : ''
            }`}
        >
            <div>{company}</div>
            <p>OhC (Overheadkosten)</p>
            <input type='number' value={OhcAmount} onChange={(event) => {
                updateOhcAmount(event.target.value);
            }}/>
            <div>EUR {revenue}</div>
        </div>
    );
}

export default LocationReportListSingle;
